<div class="user-profile-page h-full w-full overflow-y-auto bg-transparent p-4" [class.pb-[5.5rem]]="editMode()">
  @if (showCreatorsFilterBack()) {
  <div class="max-w-6xl w-full mx-auto mb-4">
    <a href="/creators-v4-filter" (click)="backToCreatorsFilter($event)"
      class="inline-flex w-fit items-center gap-2 rounded-full border border-border bg-secondary px-3 py-1.5 text-sm font-semibold text-secondary-foreground transition-opacity hover:opacity-80">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M19 12H5" />
        <path d="m12 19-7-7 7-7" />
      </svg>
      Back to creators
    </a>
  </div>
  }
  @if (showProfileReturnBack()) {
  <div class="max-w-6xl w-full mx-auto mb-4">
    <a href="/" (click)="backToProfileReturn($event)"
      class="inline-flex w-fit items-center gap-2 rounded-full border border-border bg-secondary px-3 py-1.5 text-sm font-semibold text-secondary-foreground transition-opacity hover:opacity-80">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M19 12H5" />
        <path d="m12 19-7-7 7-7" />
      </svg>
      Back
    </a>
  </div>
  }
  @switch (loadingState()) {
  @case ('loading') {
  <atom-loading-inline title="Loading user profile" message="Fetching user details..." />
  }
  @case ('error') {
  <p class="m-0 text-base text-destructive">Unable to load user profile.</p>
  }
  @case ('loaded') {
  @if (creator(); as c) {
  <div class="flex flex-col gap-4 max-w-6xl w-full mx-auto">
    <section
      class="flex flex-wrap items-center justify-between gap-4 rounded-xl border-2 border-zinc-400/35 bg-zinc-200/80 p-4 sm:p-5 dark:border-zinc-500/45 dark:bg-indigo-800/20">
      <div class="flex items-center gap-4 min-w-0">
        <div class="relative shrink-0">
          @if (c.photoURL) {
          <img [src]="imageService.getImageSource(c.photoURL, 'gallery')"
            alt="Profile picture for {{ c.firstName }} {{ c.lastName }}"
            class="size-24 rounded-full object-cover border border-border/60"
            [class.opacity-50]="photoUploadingState()" />
          } @else {
          <div
            class="size-24 rounded-full border border-border/60 bg-muted/50 flex items-center justify-center text-secondary"
            aria-hidden="true">
            <svg class="size-8" viewBox="0 0 24 24" fill="currentColor">
              <path fill-rule="evenodd"
                d="M18.685 19.097A9.723 9.723 0 0 0 21.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 0 0 3.065 7.097A9.716 9.716 0 0 0 12 21.75a9.716 9.716 0 0 0 6.685-2.653Zm-12.54-1.285A7.486 7.486 0 0 1 12 15a7.486 7.486 0 0 1 5.855 2.812A8.224 8.224 0 0 1 12 20.25a8.224 8.224 0 0 1-5.855-2.438ZM15.75 9a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"
                clip-rule="evenodd" />
            </svg>
          </div>
          }

          @if (photoUploadingState()) {
          <div class="absolute inset-0 flex items-center justify-center rounded-full bg-black/40" aria-live="polite">
            <p class="m-0 text-xs font-semibold text-white">Uploading…</p>
          </div>
          }

          @if (editMode()) {
          <input
            #profilePhotoInput
            id="profilePhotoInput"
            type="file"
            accept="image/*"
            class="sr-only"
            [disabled]="photoUploadingState()"
            (change)="onProfilePhotoSelected($event)"
          />
          <button
            type="button"
            class="absolute -bottom-1 -right-1 inline-flex size-9 items-center justify-center rounded-full border border-border bg-card text-primary shadow-sm transition-opacity hover:opacity-80 disabled:cursor-not-allowed disabled:opacity-50"
            (click)="profilePhotoInput.click()"
            [disabled]="photoUploadingState()"
            aria-label="Change profile picture"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M12 20h9" />
              <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
            </svg>
          </button>
          }
        </div>

        <button type="button" (click)="toggleEditMode()"
          class="rounded-full p-2 border border-border/60 bg-card/50 hover:opacity-80 transition-opacity cursor-pointer shrink-0"
          [attr.aria-label]="editMode() ? 'Lock profile (view only)' : 'Unlock profile (edit)'"
          [attr.aria-pressed]="editMode()">
          @if (editMode()) {
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-red-500"
            aria-hidden="true">
            <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 9.9-1" />
          </svg>
          } @else {
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-green-500"
            aria-hidden="true">
            <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
          }
        </button>
      </div>

      <div class="flex flex-col items-end gap-1 min-w-0 ml-auto">
        <h1 class="text-lg font-semibold text-primary m-0 text-right">{{ c.firstName }} {{ c.lastName }}</h1>
        @if (c.blazeFirebaseUid) {
        <atom-copy-id [value]="c.blazeFirebaseUid" label="blazeFirebaseUid" align="end" />
        }
      </div>

    </section>

    @if (!editMode()) {
    <section
      class="rounded-xl border-2 border-zinc-400/35 bg-zinc-200/80 p-4 sm:p-5 dark:border-zinc-500/45 dark:bg-indigo-800/20">
      <h2 class="m-0 mb-3 text-base font-semibold tracking-wide text-primary">Profile</h2>
      <div class="grid grid-cols-[7fr_3fr] items-start gap-4">
        <div class="min-w-0">
          <p class="m-0 text-sm text-secondary">About</p>
          <p class="m-0 mt-1 text-base text-primary whitespace-pre-wrap break-words">{{ displayValue(c.bio) }}</p>
        </div>
        <div class="min-w-0">
          <p class="m-0 text-sm text-secondary">Creator rank</p>
          <p class="m-0 mt-1 text-base text-primary">{{ displayValue(c.rank) }}</p>
        </div>
      </div>
    </section>

    <section
      class="rounded-xl border-2 border-zinc-400/35 bg-zinc-200/80 p-4 sm:p-5 dark:border-zinc-500/45 dark:bg-indigo-800/20">
      <h2 class="m-0 mb-3 text-base font-semibold tracking-wide text-primary">Email</h2>
      <p class="m-0 mt-1 text-base text-primary">{{ displayValue(c.email) }}</p>
    </section>

    <section
      class="rounded-xl border-2 border-amber-400/35 bg-amber-200/80 p-4 sm:p-5 dark:border-amber-500/45 dark:bg-amber-800/20">
      <h2 class="m-0 mb-3 text-base font-semibold tracking-wide text-primary">Account status</h2>
      <div class="grid grid-cols-1 gap-4 sm:grid-cols-3">
        <div class="flex items-start gap-3 min-w-0">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            [class]="statusFlagIconClass(c.isActive)" aria-hidden="true">
            <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
          <div class="min-w-0">
            <p class="m-0 text-sm text-secondary">isActive</p>
            <p class="m-0 mt-1 text-base font-medium" [class]="booleanFlagColorClass(c.isActive)">
              {{ booleanFlagLabel(c.isActive) }}
            </p>
          </div>
        </div>

        <div class="flex items-start gap-3 min-w-0">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            [class]="statusFlagIconClass(c.mobileVerified)" aria-hidden="true">
            <rect width="14" height="20" x="5" y="2" rx="2" ry="2" />
            <path d="M12 18h.01" />
          </svg>
          <div class="min-w-0">
            <p class="m-0 text-sm text-secondary">mobileVerified</p>
            <p class="m-0 mt-1 text-base font-medium" [class]="booleanFlagColorClass(c.mobileVerified)">
              {{ booleanFlagLabel(c.mobileVerified) }}
            </p>
          </div>
        </div>

        <div class="flex items-start gap-3 min-w-0">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            [class]="moderationStatusIconClass()" aria-hidden="true">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 16v-4" />
            <path d="M12 8h.01" />
          </svg>
          <div class="min-w-0">
            <p class="m-0 text-sm text-secondary">moderationStaus</p>
            <p class="m-0 mt-1 text-base font-medium" [class]="moderationStatusColorClass()">
              {{ moderationStatusLabel() }}
            </p>
          </div>
        </div>
      </div>

      @if (moderationHistoryLoading()) {
      <p class="m-0 mt-4 text-sm text-secondary">Loading moderation details…</p>
      } @else if (moderationFailureReasons().length > 0) {
      <div class="mt-4 rounded-lg border border-red-400/35 bg-red-100/70 p-3 dark:border-red-500/40 dark:bg-red-900/30">
        <p class="m-0 text-sm font-semibold text-red-700 dark:text-red-300">Moderation reasons</p>
        <ul class="mt-2 list-disc space-y-1 pl-5">
          @for (reason of moderationFailureReasons(); track reason) {
          <li>
            <p class="m-0 text-sm text-red-700 dark:text-red-300">{{ reason }}</p>
          </li>
          }
        </ul>
      </div>
      }
    </section>

    <section
      class="rounded-xl border-2 border-zinc-400/35 bg-zinc-200/80 p-4 sm:p-5 dark:border-zinc-500/45 dark:bg-indigo-800/20">
      <h2 class="m-0 mb-3 text-base font-semibold tracking-wide text-primary">Personal information</h2>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <div>
          <p class="m-0 text-sm text-secondary">First name</p>
          <p class="m-0 mt-1 text-base text-primary">{{ displayValue(c.firstName) }}</p>
        </div>
        <div>
          <p class="m-0 text-sm text-secondary">Last name</p>
          <p class="m-0 mt-1 text-base text-primary">{{ displayValue(c.lastName) }}</p>
        </div>
        <div>
          <p class="m-0 text-sm text-secondary">Mobile</p>
          <p class="m-0 mt-1 text-base text-primary">{{ displayValue(c.mobile) }}</p>
        </div>
        <div>
          <p class="m-0 text-sm text-secondary">Hometown</p>
          <p class="m-0 mt-1 text-base text-primary">{{ displayValue(c.homeTownName) }}</p>
        </div>
        <div>
          <p class="m-0 text-sm text-secondary">Country</p>
          @if (countryOptionFor(c.countryCode); as country) {
          <div class="mt-1 flex items-center gap-2">
            <img [src]="country.flagUrl" [alt]="country.label" class="h-4 w-6 shrink-0 rounded-sm object-cover" />
            <p class="m-0 text-base text-primary">{{ country.label }}</p>
          </div>
          } @else {
          <p class="m-0 mt-1 text-base text-primary">{{ displayValue(c.countryCode) }}</p>
          }
        </div>
        <div>
          <p class="m-0 text-sm text-secondary">Currency</p>
          @if (currencyOptionFor(c.currencyCode); as currency) {
          <div class="mt-1 flex items-center gap-2">
            <img [src]="currency.flagUrl" [alt]="currency.label" class="h-4 w-6 shrink-0 rounded-sm object-cover" />
            <p class="m-0 text-base text-primary">{{ currency.label }}</p>
          </div>
          } @else {
          <p class="m-0 mt-1 text-base text-primary">{{ displayValue(c.currencyCode) }}</p>
          }
        </div>
      </div>
    </section>
    } @else {
    <section
      class="rounded-xl border-2 border-rose-400/35 bg-rose-200/80 p-4 sm:p-5 dark:border-rose-500/45 dark:bg-rose-800/20">
      <h2 class="m-0 mb-3 text-base font-semibold tracking-wide text-primary">Email</h2>
      <p class="m-0 mb-3 text-sm text-accent">Important! Use with caution!</p>
      <p class="m-0 mb-3 text-sm text-secondary">
        Updates Firebase Auth and the creator record separately from other profile fields.
      </p>
      <div class="flex flex-col gap-3 sm:flex-row sm:items-end">
        <div class="min-w-0 flex-1">
          <label for="email" class="block text-sm text-secondary">Email address</label>
          <input id="email" type="email" [formField]="creatorProfileForm.email"
            class="mt-1 block w-full input-primary text-primary" autocomplete="off" />
        </div>
        <button type="button" class="btn-basic btn-primary shrink-0 min-w-36" (click)="saveEmail()"
          [disabled]="!canSaveEmail()">
          {{ emailSavingState() ? 'Updating…' : 'Update email' }}
        </button>
      </div>
      @if (emailJustUpdated()) {
      <div
        class="mt-4 flex flex-col gap-2 rounded-lg border border-zinc-400/30 bg-zinc-100/60 p-3 dark:border-zinc-500/35 dark:bg-zinc-900/40 sm:flex-row sm:items-center sm:justify-between">
        <p class="m-0 text-sm text-secondary">
          Email saved. Optionally send a password reset to the new address.
        </p>
        <button type="button" class="btn-basic btn-secondary-outline shrink-0" (click)="sendPasswordReset()"
          [disabled]="!canSendPasswordReset()">
          {{ passwordResetSendingState() ? 'Sending…' : 'Send password reset email' }}
        </button>
      </div>
      }
    </section>

    <section
      class="rounded-xl border-2 border-amber-400/35 bg-amber-200/80 p-4 sm:p-5 dark:border-amber-500/45 dark:bg-amber-800/20">
      <h2 class="m-0 mb-3 text-base font-semibold tracking-wide text-primary">Account status</h2>
      <p class="m-0 mb-3 text-sm text-secondary">
        Updates active and mobile-verified flags separately from profile fields. Re-run moderation independently.
      </p>

      <div class="grid grid-cols-1 gap-4 sm:grid-cols-3">
        <div class="flex items-start gap-3 min-w-0">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            [class]="statusFlagIconClass(statusFlagsDraft()?.isActive ?? c.isActive)"
            aria-hidden="true">
            <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
          <div class="min-w-0 flex-1">
            <p class="m-0 text-sm text-secondary">isActive</p>
            <button
              type="button"
              [class]="statusFlagToggleClass(statusFlagsDraft()?.isActive ?? c.isActive)"
              (click)="toggleStatusFlag('isActive')"
              [attr.aria-pressed]="statusFlagsDraft()?.isActive ?? c.isActive"
              aria-label="Toggle isActive">
              {{ booleanFlagLabel(statusFlagsDraft()?.isActive ?? c.isActive) }}
            </button>
          </div>
        </div>

        <div class="flex items-start gap-3 min-w-0">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            [class]="statusFlagIconClass(statusFlagsDraft()?.mobileVerified ?? c.mobileVerified)"
            aria-hidden="true">
            <rect width="14" height="20" x="5" y="2" rx="2" ry="2" />
            <path d="M12 18h.01" />
          </svg>
          <div class="min-w-0 flex-1">
            <p class="m-0 text-sm text-secondary">mobileVerified</p>
            <button
              type="button"
              [class]="statusFlagToggleClass(statusFlagsDraft()?.mobileVerified ?? c.mobileVerified)"
              (click)="toggleStatusFlag('mobileVerified')"
              [attr.aria-pressed]="statusFlagsDraft()?.mobileVerified ?? c.mobileVerified"
              aria-label="Toggle mobileVerified">
              {{ booleanFlagLabel(statusFlagsDraft()?.mobileVerified ?? c.mobileVerified) }}
            </button>
          </div>
        </div>

        <div class="flex items-start gap-3 min-w-0">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            [class]="moderationStatusIconClass()" aria-hidden="true">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 16v-4" />
            <path d="M12 8h.01" />
          </svg>
          <div class="min-w-0 flex-1">
            <p class="m-0 text-sm text-secondary">moderationStaus</p>
            <p class="m-0 mt-1 text-base font-medium" [class]="moderationStatusColorClass()">
              {{ moderationStatusLabel() }}
            </p>
            @if (showRerunModeration()) {
            <button
              type="button"
              class="btn-basic btn-secondary-outline mt-2 shrink-0"
              (click)="rerunModeration()"
              [disabled]="!canRerunModeration()">
              {{ moderationRerunningState() ? 'Re-running…' : 'Re-run moderation' }}
            </button>
            }
          </div>
        </div>
      </div>

      <div class="mt-4 flex justify-end">
        <button
          type="button"
          class="btn-basic btn-primary shrink-0 min-w-36"
          (click)="saveStatusFlags()"
          [disabled]="!canSaveStatusFlags()">
          {{ statusFlagsSavingState() ? 'Saving…' : 'Save status flags' }}
        </button>
      </div>

      @if (moderationHistoryLoading()) {
      <p class="m-0 mt-4 text-sm text-secondary">Loading moderation details…</p>
      } @else if (moderationFailureReasons().length > 0) {
      <div class="mt-4 rounded-lg border border-red-400/35 bg-red-100/70 p-3 dark:border-red-500/40 dark:bg-red-900/30">
        <p class="m-0 text-sm font-semibold text-red-700 dark:text-red-300">Moderation reasons</p>
        <ul class="mt-2 list-disc space-y-1 pl-5">
          @for (reason of moderationFailureReasons(); track reason) {
          <li>
            <p class="m-0 text-sm text-red-700 dark:text-red-300">{{ reason }}</p>
          </li>
          }
        </ul>
      </div>
      }
    </section>

    <form class="flex flex-col gap-4">
      <section
        class="rounded-xl border-2 border-zinc-400/35 bg-zinc-200/80 p-4 sm:p-5 dark:border-zinc-500/45 dark:bg-indigo-800/20">
        <h2 class="m-0 mb-3 text-base font-semibold tracking-wide text-primary">Profile</h2>
        <div class="grid grid-cols-[7fr_3fr] items-start gap-4">
          <div class="min-w-0">
            <label for="bio" class="block text-sm text-secondary">About</label>
            <textarea id="bio" rows="3" [formField]="creatorProfileForm.bio"
              class="mt-1 block w-full min-h-20 resize-y input-primary text-primary"></textarea>
          </div>
          <div class="min-w-0">
            <label for="rank" class="block text-sm text-secondary">Creator rank</label>
            <input id="rank" type="number" [formField]="creatorProfileForm.rank"
              class="mt-1 block w-full input-primary text-primary" />
          </div>
        </div>
      </section>

      <section
        class="rounded-xl border-2 border-zinc-400/35 bg-zinc-200/80 p-4 sm:p-5 dark:border-zinc-500/45 dark:bg-indigo-800/20">
        <h2 class="m-0 mb-3 text-base font-semibold tracking-wide text-primary">Personal information</h2>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div>
            <label for="firstName" class="block text-sm text-secondary">First name</label>
            <input id="firstName" type="text" [formField]="creatorProfileForm.firstName"
              class="mt-1 block w-full input-primary text-primary" />
          </div>
          <div>
            <label for="lastName" class="block text-sm text-secondary">Last name</label>
            <input id="lastName" type="text" [formField]="creatorProfileForm.lastName"
              class="mt-1 block w-full input-primary text-primary" />
          </div>
          <div>
            <label for="mobile" class="block text-sm text-secondary">Mobile</label>
            <input id="mobile" type="text" [formField]="creatorProfileForm.mobile"
              class="mt-1 block w-full input-primary text-primary" />
          </div>
          <div>
            <label for="homeTownName" class="block text-sm text-secondary">Hometown</label>
            <input id="homeTownName" type="text" [formField]="creatorProfileForm.homeTownName"
              class="mt-1 block w-full input-primary text-primary" />
          </div>
          <div>
            <label for="countryCode" class="block text-sm text-secondary">Country</label>
            <el-select id="countryCode" name="countryCode" class="mt-1 block w-full"
              [value]="creatorProfileModel().countryCode">
              <button type="button" class="grid w-full grid-cols-1 text-primary dropdown-select-primary-btn">
                <el-selectedcontent class="col-start-1 row-start-1 flex items-center gap-2 truncate pr-6">
                  @if (selectedCountryOption(); as country) {
                  <img [src]="country.flagUrl" [alt]="country.label" class="h-4 w-6 shrink-0 rounded-sm object-cover" />
                  <p class="m-0 truncate">{{ country.label }}</p>
                  } @else {
                  <p class="m-0 truncate text-secondary">Select country</p>
                  }
                </el-selectedcontent>
                <svg viewBox="0 0 16 16" fill="currentColor" data-slot="icon" aria-hidden="true"
                  class="col-start-1 row-start-1 size-5 self-center justify-self-end text-secondary sm:size-4">
                  <path
                    d="M5.22 10.22a.75.75 0 0 1 1.06 0L8 11.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-2.25 2.25a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 0 1 0-1.06ZM10.78 5.78a.75.75 0 0 1-1.06 0L8 4.06 6.28 5.78a.75.75 0 0 1-1.06-1.06l2.25-2.25a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06Z"
                    clip-rule="evenodd" fill-rule="evenodd" />
                </svg>
              </button>
              <el-options anchor="bottom start" popover class="dropdown-select-primary-menu">
                @for (country of countryOptions; track country.value) {
                <el-option [value]="country.value" (click)="onCountrySelected(country.value)"
                  class="group/option relative block cursor-pointer py-2 pr-9 pl-3 text-primary select-none focus:bg-primary focus:text-primary-foreground focus:outline-hidden">
                  <div class="flex items-center gap-2">
                    <img [src]="country.flagUrl" [alt]="country.label"
                      class="h-4 w-6 shrink-0 rounded-sm object-cover" />
                    <p class="m-0 truncate font-normal group-aria-selected/option:font-semibold">{{ country.label }}</p>
                  </div>
                  <span
                    class="absolute inset-y-0 right-0 flex items-center pr-4 text-accent group-not-aria-selected/option:hidden group-focus/option:text-primary-foreground in-[el-selectedcontent]:hidden">
                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true" class="size-5">
                      <path
                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                        clip-rule="evenodd" fill-rule="evenodd" />
                    </svg>
                  </span>
                </el-option>
                }
              </el-options>
            </el-select>
          </div>
          <div>
            <label for="currencyCode" class="block text-sm text-secondary">Currency</label>
            <el-select id="currencyCode" name="currencyCode" class="mt-1 block w-full"
              [value]="creatorProfileModel().currencyCode">
              <button type="button" class="grid w-full grid-cols-1 text-primary dropdown-select-primary-btn">
                <el-selectedcontent class="col-start-1 row-start-1 flex items-center gap-2 truncate pr-6">
                  @if (selectedCurrencyOption(); as currency) {
                  <img [src]="currency.flagUrl" [alt]="currency.label"
                    class="h-4 w-6 shrink-0 rounded-sm object-cover" />
                  <p class="m-0 truncate">{{ currency.label }}</p>
                  } @else {
                  <p class="m-0 truncate text-secondary">Select currency</p>
                  }
                </el-selectedcontent>
                <svg viewBox="0 0 16 16" fill="currentColor" data-slot="icon" aria-hidden="true"
                  class="col-start-1 row-start-1 size-5 self-center justify-self-end text-secondary sm:size-4">
                  <path
                    d="M5.22 10.22a.75.75 0 0 1 1.06 0L8 11.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-2.25 2.25a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 0 1 0-1.06ZM10.78 5.78a.75.75 0 0 1-1.06 0L8 4.06 6.28 5.78a.75.75 0 0 1-1.06-1.06l2.25-2.25a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06Z"
                    clip-rule="evenodd" fill-rule="evenodd" />
                </svg>
              </button>
              <el-options anchor="bottom start" popover class="dropdown-select-primary-menu">
                @for (currency of currencyOptions; track currency.value) {
                <el-option [value]="currency.value" (click)="onCurrencySelected(currency.value)"
                  class="group/option relative block cursor-pointer py-2 pr-9 pl-3 text-primary select-none focus:bg-primary focus:text-primary-foreground focus:outline-hidden">
                  <div class="flex items-center gap-2">
                    <img [src]="currency.flagUrl" [alt]="currency.label"
                      class="h-4 w-6 shrink-0 rounded-sm object-cover" />
                    <p class="m-0 truncate font-normal group-aria-selected/option:font-semibold">{{ currency.label }}
                    </p>
                  </div>
                  <span
                    class="absolute inset-y-0 right-0 flex items-center pr-4 text-accent group-not-aria-selected/option:hidden group-focus/option:text-primary-foreground in-[el-selectedcontent]:hidden">
                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true" class="size-5">
                      <path
                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                        clip-rule="evenodd" fill-rule="evenodd" />
                    </svg>
                  </span>
                </el-option>
                }
              </el-options>
            </el-select>
          </div>
        </div>
      </section>
    </form>
    }

    @if (!editMode()) {
    <section
      class="rounded-xl border-2 border-zinc-400/35 bg-zinc-200/80 p-4 sm:p-5 dark:border-zinc-500/45 dark:bg-indigo-800/20">
      <h2 class="m-0 mb-3 text-base font-semibold tracking-wide text-primary">Delivery address</h2>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <div>
          <p class="m-0 text-sm text-secondary">Full name</p>
          <p class="m-0 mt-1 text-base text-primary">{{ displayValue(deliveryAddress()?.fullName) }}</p>
        </div>
        <div>
          <p class="m-0 text-sm text-secondary">Postcode</p>
          <p class="m-0 mt-1 text-base text-primary">{{ displayValue(deliveryAddress()?.postcode) }}</p>
        </div>
        <div>
          <p class="m-0 text-sm text-secondary">Address line 1</p>
          <p class="m-0 mt-1 text-base text-primary">{{ displayValue(deliveryAddress()?.addressLine1) }}</p>
        </div>
        <div>
          <p class="m-0 text-sm text-secondary">Address line 2</p>
          <p class="m-0 mt-1 text-base text-primary">{{ displayValue(deliveryAddress()?.addressLine2) }}</p>
        </div>
        <div>
          <p class="m-0 text-sm text-secondary">Town</p>
          <p class="m-0 mt-1 text-base text-primary">{{ displayValue(deliveryAddress()?.town) }}</p>
        </div>
        <div>
          <p class="m-0 text-sm text-secondary">Country</p>
          <p class="m-0 mt-1 text-base text-primary">{{ displayValue(deliveryAddress()?.country) }}</p>
        </div>
      </div>
    </section>
    } @else {
    <form class="flex flex-col gap-4">
      <section
        class="rounded-xl border-2 border-zinc-400/35 bg-zinc-200/80 p-4 sm:p-5 dark:border-zinc-500/45 dark:bg-indigo-800/20">
        <h2 class="m-0 mb-3 text-base font-semibold tracking-wide text-primary">Delivery address</h2>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div>
            <label for="deliveryFullName" class="block text-sm text-secondary">Full name</label>
            <input id="deliveryFullName" type="text" [formField]="creatorProfileForm.deliveryFullName"
              class="mt-1 block w-full input-primary text-primary" />
          </div>
          <div>
            <label for="deliveryPostcode" class="block text-sm text-secondary">Postcode</label>
            <input id="deliveryPostcode" type="text" [formField]="creatorProfileForm.deliveryPostcode"
              class="mt-1 block w-full input-primary text-primary" />
          </div>
          <div>
            <label for="deliveryAddressLine1" class="block text-sm text-secondary">Address line 1</label>
            <input id="deliveryAddressLine1" type="text" [formField]="creatorProfileForm.deliveryAddressLine1"
              class="mt-1 block w-full input-primary text-primary" />
          </div>
          <div>
            <label for="deliveryAddressLine2" class="block text-sm text-secondary">Address line 2</label>
            <input id="deliveryAddressLine2" type="text" [formField]="creatorProfileForm.deliveryAddressLine2"
              class="mt-1 block w-full input-primary text-primary" />
          </div>
          <div>
            <label for="deliveryTown" class="block text-sm text-secondary">Town</label>
            <input id="deliveryTown" type="text" [formField]="creatorProfileForm.deliveryTown"
              class="mt-1 block w-full input-primary text-primary" />
          </div>
          <div>
            <label for="deliveryCountry" class="block text-sm text-secondary">Country</label>
            <input id="deliveryCountry" type="text" [formField]="creatorProfileForm.deliveryCountry"
              class="mt-1 block w-full input-primary text-primary" />
          </div>
        </div>
      </section>
    </form>
    }

    <section
      class="rounded-xl border-2 border-zinc-400/35 bg-zinc-200/80 p-4 sm:p-5 dark:border-zinc-500/45 dark:bg-indigo-800/20">
      <h2 class="m-0 mb-3 text-base font-semibold tracking-wide text-primary">Socials</h2>
      <p class="m-0 mb-4 text-sm text-secondary">
        Platform data is managed by SuperSocial. Creator record handles are shown for comparison and can be synced in
        edit mode.
      </p>

      @if (superSocialLoading()) {
      <p class="m-0 text-base text-secondary">Loading SuperSocial accounts…</p>
      }

      <ul class="m-0 flex list-none flex-col gap-4 p-0">
        @for (platform of socialPlatforms; track platform.key) {
        @let account = getSuperSocialAccount(platform.key);
        @let match = getHandleMatchStatus(platform);

        <li
          class="rounded-[0.625rem] border border-zinc-400/30 bg-zinc-300/60 p-3.5 dark:border-zinc-500/40 dark:bg-zinc-900/60">
          <div class="flex flex-wrap items-start gap-4">
            @if (account; as socialAccount) {
            @if (socialAccount.avatarUrl) {
            <img [src]="socialAccount.avatarUrl" [alt]="platform.label + ' profile'"
              class="size-16 shrink-0 rounded-full border border-border/60 object-cover" width="64" height="64" />
            }
            }

            <div class="min-w-0 flex-1">
              <div class="flex flex-wrap items-center justify-between gap-2">
                <p class="m-0 text-base font-semibold text-primary">{{ platform.label }}</p>

                @if (editMode() && account && supportsSuperSocialAccountRefresh(account.platform)) {
                <div class="flex shrink-0 flex-wrap items-center gap-2">
                  @if (isSuperSocialRefreshLoading(account.id)) {
                  <span
                    class="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-sm font-medium text-primary inset-ring inset-ring-zinc-200 dark:inset-ring-zinc-700">
                    <svg aria-hidden="true" class="size-4 animate-spin text-secondary" viewBox="0 0 100 101" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor" />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentColor" />
                    </svg>
                    Syncing account data…
                  </span>
                  } @else if (isSuperSocialRefreshSent(account.id)) {
                  <span
                    class="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-sm font-medium text-green-700 inset-ring inset-ring-green-600/20 dark:bg-green-400/10 dark:text-green-400 dark:inset-ring-green-500/20">Refresh
                    request sent!</span>
                  } @else {
                  <button type="button" class="btn-shout btn-shout-xs btn-shout-primary inline-flex items-center gap-x-1.5"
                    (click)="refreshSuperSocialAccount(account)">
                    Refresh Account
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="-mr-0.5 size-5" aria-hidden="true">
                      <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
                      <path d="M3 3v5h5" />
                      <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" />
                      <path d="M16 16h5v5" />
                    </svg>
                  </button>
                  }
                  <button
                    type="button"
                    class="rounded-md px-2 py-1 text-sm font-medium text-red-700 inset-ring inset-ring-red-600/20 hover:bg-red-50 dark:text-red-400 dark:inset-ring-red-500/30 dark:hover:bg-red-950/40 disabled:opacity-50"
                    (click)="removeSuperSocialAccount(account)"
                    [disabled]="isRemoveAccountLoading(account.id)"
                  >
                    @if (isRemoveAccountLoading(account.id)) {
                      Removing…
                    } @else {
                      Remove account
                    }
                  </button>
                </div>
                } @else if (editMode() && account && platform.superSocialSupported) {
                <div class="flex shrink-0 items-center">
                  <button
                    type="button"
                    class="rounded-md px-2 py-1 text-sm font-medium text-red-700 inset-ring inset-ring-red-600/20 hover:bg-red-50 dark:text-red-400 dark:inset-ring-red-500/30 dark:hover:bg-red-950/40 disabled:opacity-50"
                    (click)="removeSuperSocialAccount(account)"
                    [disabled]="isRemoveAccountLoading(account.id)"
                  >
                    @if (isRemoveAccountLoading(account.id)) {
                      Removing…
                    } @else {
                      Remove account
                    }
                  </button>
                </div>
                }
              </div>

              <div class="mt-3 grid grid-cols-1 gap-3 md:grid-cols-2">
                <div
                  class="rounded-lg border border-zinc-400/28 bg-zinc-100/60 p-3 dark:border-zinc-500/35 dark:bg-zinc-600/60">
                  <p class="m-0 text-sm font-medium text-secondary">Creator record</p>
                  @if (editMode()) {
                  <label class="mt-2 block text-sm text-secondary"
                    [attr.for]="'creator-handle-' + platform.key">Handle</label>
                  <input [id]="'creator-handle-' + platform.key" type="text"
                    class="mt-1 block w-full input-primary text-primary" [value]="getCreatorHandleEdit(platform.key)"
                    (input)="onCreatorHandleEdit(platform.key, $any($event.target).value)" />
                  } @else {
                  <p class="m-0 mt-2 text-base text-primary">@{{ displayValue(getCreatorHandle(platform.key, c)) }}</p>
                  }
                  <p class="m-0 mt-2 text-sm text-secondary">{{ platform.followersLabel }}</p>
                  <p class="m-0 mt-1 text-base text-primary">{{ getCreatorFollowers(platform.key, c) | number }}</p>
                </div>

                @if (platform.superSocialSupported) {
                <div
                  class="rounded-lg border border-zinc-400/28 bg-zinc-100/60 p-3 dark:border-zinc-500/35 dark:bg-zinc-600/60">
                  <p class="m-0 text-sm font-medium text-secondary">SuperSocial</p>
                  @if (account) {
                  <p class="m-0 mt-2 text-base text-primary">@{{ displayValue(superSocialAccountHandleValue(account)) }}
                  </p>
                  <p class="m-0 mt-2 text-sm text-secondary">source</p>
                  <p class="m-0 mt-1 text-base text-primary">{{ account.source ?? '—' }}</p>
                  } @else {
                  <p class="m-0 mt-2 text-base text-primary">No connected account</p>
                  }
                </div>
                }
              </div>

              <p class="m-0 mt-3 text-sm" [class.text-green-500]="match.tone === 'match'"
                [class.text-amber-500]="match.tone === 'mismatch'"
                [class.text-secondary]="match.tone === 'no-super-social' || match.tone === 'snapchat'"
                [class.text-orange-500]="match.tone === 'missing-creator' || match.tone === 'missing-super-social'">
                {{ match.message }}
              </p>

              @if (editMode() && platform.superSocialSupported && account) {
              @let superSocialHandle = superSocialAccountHandleValue(account);
              @if (superSocialHandle && !superSocialHandlesMatch(getCreatorHandleEdit(platform.key), superSocialHandle))
              {
              <label class="mt-3 flex cursor-pointer items-start gap-2 text-sm text-primary">
                <input type="checkbox" class="mt-0.5" [checked]="isSyncFromSuperSocial(platform.key)"
                  (change)="onSyncFromSuperSocial(platform.key, $any($event.target).checked)" />
                <span>Use SuperSocial handle (@{{ superSocialHandle }}) on creator record</span>
              </label>
              }
              }
            </div>
          </div>

          @if (account) {
          <dl class="mt-4 grid gap-1 border-t border-border/40 pt-4 text-base sm:grid-cols-2">
            <div>
              <dt class="inline font-medium text-secondary">id: </dt>
              <dd class="inline break-all font-mono text-sm text-primary">{{ account.id }}</dd>
            </div>
            <div>
              <dt class="inline font-medium text-secondary">createdDate: </dt>
              <dd class="inline text-primary">{{ account.createdDate ?? '—' }}</dd>
            </div>
            <div>
              <dt class="inline font-medium text-secondary">updatedDate: </dt>
              <dd class="inline" [class]="superSocialUpdatedDateColour(account.updatedDateIso)">{{ account.updatedDate
                ?? '—' }}</dd>
            </div>

            @if (account.platform === 'instagram') {
            <div>
              <dt class="inline font-medium text-secondary">name: </dt>
              <dd class="inline text-primary">{{ account.name ?? '—' }}</dd>
            </div>
            <div>
              <dt class="inline font-medium text-secondary">followers_count: </dt>
              <dd class="inline text-primary">{{ formatNumber(account.followers_count) }}</dd>
            </div>
            <div>
              <dt class="inline font-medium text-secondary">media_count: </dt>
              <dd class="inline text-primary">{{ formatNumber(account.media_count) }}</dd>
            </div>
            <div>
              <dt class="inline font-medium text-secondary">totalViews: </dt>
              <dd class="inline text-primary">{{ formatNumber(account.totalViews) }}</dd>
            </div>
            }

            @if (account.platform === 'tiktok') {
            <div>
              <dt class="inline font-medium text-secondary">displayName: </dt>
              <dd class="inline text-primary">{{ account.displayName ?? '—' }}</dd>
            </div>
            <div>
              <dt class="inline font-medium text-secondary">followers_count: </dt>
              <dd class="inline text-primary">{{ formatNumber(account.followers_count) }}</dd>
            </div>
            <div>
              <dt class="inline font-medium text-secondary">media_count: </dt>
              <dd class="inline text-primary">{{ formatNumber(account.media_count) }}</dd>
            </div>
            <div>
              <dt class="inline font-medium text-secondary">totalViews: </dt>
              <dd class="inline text-primary">{{ formatNumber(account.totalViews) }}</dd>
            </div>
            }

            @if (account.platform === 'youtube') {
            <div>
              <dt class="inline font-medium text-secondary">title: </dt>
              <dd class="inline text-primary">{{ account.title ?? '—' }}</dd>
            </div>
            <div>
              <dt class="inline font-medium text-secondary">subscriber_count: </dt>
              <dd class="inline text-primary">{{ formatNumber(account.subscriber_count) }}</dd>
            </div>
            <div>
              <dt class="inline font-medium text-secondary">video_count: </dt>
              <dd class="inline text-primary">{{ formatNumber(account.video_count) }}</dd>
            </div>
            <div>
              <dt class="inline font-medium text-secondary">view_count: </dt>
              <dd class="inline text-primary">{{ formatNumber(account.view_count) }}</dd>
            </div>
            }
          </dl>
          }
        </li>
        }
      </ul>
    </section>

    <!-- SHOUT+ configuration (Join SHOUT+) -->
    <section
      class="rounded-xl border-2 border-zinc-400/35 bg-zinc-200/80 p-4 sm:p-5 dark:border-zinc-500/45 dark:bg-indigo-800/20">
      <div class="mb-3 flex items-center justify-between gap-3">
        <h2 class="m-0 text-base font-semibold tracking-wide text-primary">SHOUT+ configuration</h2>
        @if (shoutPlusLoading()) {
        <p class="m-0 text-sm text-secondary">Loading…</p>
        }
      </div>

      <div class="mb-4 flex flex-col gap-2">
        <label for="shout-plus-brand-search" class="m-0 text-sm font-medium text-secondary">Brand</label>

        @if (selectedShoutPlusBrand(); as brand) {
        <div
          class="flex flex-wrap items-center gap-3 rounded-lg border border-zinc-400/35 bg-white/70 px-3 py-2 dark:border-zinc-500/45 dark:bg-zinc-900/40">
          <div
            class="size-9 shrink-0 overflow-hidden rounded-full bg-zinc-100 ring-1 ring-zinc-200/80 dark:bg-zinc-800 dark:ring-zinc-700">
            @if (brand.companyLogo) {
            <img
              [src]="imageService.getImageSource(brand.companyLogo, 'gallery')"
              alt=""
              class="size-full object-cover" />
            }
          </div>
          <div class="min-w-0 flex-1">
            <p class="m-0 truncate text-sm font-semibold text-primary">{{ brand.companyName }}</p>
            <p class="m-0 truncate text-xs text-secondary">{{ brand.id }}</p>
          </div>
          <button
            type="button"
            class="btn-shout btn-shout-xs btn-shout-secondary shrink-0"
            (click)="clearShoutPlusBrand()">
            Change
          </button>
        </div>
        } @else {
        <div class="relative">
          <input
            id="shout-plus-brand-search"
            type="search"
            autocomplete="off"
            placeholder="Search brand name or paste business ID…"
            class="input-primary w-full"
            [value]="shoutPlusBrandSearch()"
            (input)="onShoutPlusBrandSearchInput($event)"
            (focus)="openShoutPlusBrandPicker()" />

          @if (shoutPlusBrandPickerOpen() && (shoutPlusBrandSearchLoading() || shoutPlusBrandResults().length || shoutPlusBrandSearch().trim().length >= 2)) {
          <ul
            class="absolute z-20 mt-1 max-h-60 w-full overflow-y-auto rounded-lg border border-zinc-300 bg-white p-1 shadow-md dark:border-zinc-600 dark:bg-zinc-900"
            role="listbox"
            aria-label="Brand search results">
            @if (shoutPlusBrandSearchLoading()) {
            <li class="px-3 py-2 text-sm text-secondary">Searching…</li>
            } @else if (shoutPlusBrandResults().length === 0) {
            <li class="px-3 py-2 text-sm text-secondary">No brands match.</li>
            } @else {
            @for (result of shoutPlusBrandResults(); track result.id) {
            <li role="option">
              <button
                type="button"
                class="flex w-full items-center gap-3 rounded-md px-3 py-2 text-left hover:bg-zinc-100 dark:hover:bg-zinc-800"
                (click)="selectShoutPlusBrand(result)">
                <div
                  class="size-8 shrink-0 overflow-hidden rounded-full bg-zinc-100 ring-1 ring-zinc-200/80 dark:bg-zinc-800 dark:ring-zinc-700">
                  @if (result.companyLogo) {
                  <img
                    [src]="imageService.getImageSource(result.companyLogo, 'gallery')"
                    alt=""
                    class="size-full object-cover" />
                  }
                </div>
                <span class="min-w-0 flex-1">
                  <p class="m-0 truncate text-sm font-medium text-primary">
                    {{ result.companyName || 'Unnamed brand' }}
                  </p>
                  <p class="m-0 truncate text-xs text-secondary">{{ result.id }}</p>
                </span>
              </button>
            </li>
            }
            }
          </ul>
          }
        </div>
        }
      </div>

      @if (!selectedBusinessId()) {
      <p class="m-0 text-sm text-amber-700 dark:text-amber-300">
        Select a brand first to manage SHOUT+ membership for this creator.
      </p>
      } @else if (shoutPlusCreator(); as shoutPlus) {
      <div class="flex flex-wrap items-center gap-4">
        <div
          class="pill"
          [class.pill-indigo]="(shoutPlus.status_pill_class ?? '') === 'pill-indigo'"
          [class.pill-teal]="(shoutPlus.status_pill_class ?? '') === 'pill-teal'"
          [class.pill-rose]="(shoutPlus.status_pill_class ?? '') === 'pill-rose'"
          [class.pill-amber]="(shoutPlus.status_pill_class ?? '') === 'pill-amber'">
          {{ formatShoutPlusStatusLabel(shoutPlus.shout_plus_creator_status) }}
        </div>

        <div class="flex items-center gap-1">
          <p class="m-0 text-sm text-secondary">Date added:</p>
          <p class="m-0 text-sm font-semibold text-indigo-600 dark:text-indigo-400">
            {{ shoutPlus.created_date | date: 'dd MMM yyyy' }}
          </p>
        </div>

        <div class="flex items-center gap-2">
          <p class="m-0 text-sm text-secondary">Link ID:</p>
          <p class="m-0 text-sm font-semibold text-indigo-600 dark:text-indigo-400">{{ shoutPlus.id }}</p>
          @if (shoutPlus.id) {
          <button
            type="button"
            class="btn-basic btn-gray-outline px-2 py-1 text-sm"
            (click)="copyShoutPlusLinkId(shoutPlus.id)"
            aria-label="Copy SHOUT+ link ID">
            Copy
          </button>
          }
        </div>
      </div>
      } @else {
      <button
        type="button"
        class="btn-shout btn-shout-sm btn-shout-plus-gradient disabled:cursor-not-allowed disabled:opacity-60"
        [disabled]="joiningShoutPlus() || shoutPlusLoading()"
        (click)="joinShoutPlus()">
        {{ joiningShoutPlus() ? 'Joining...' : 'Join SHOUT+' }}
      </button>
      }
    </section>
  </div>
  } @else if (brandUser(); as u) {
  <div class="flex flex-col gap-4 max-w-6xl w-full mx-auto">
    <section
      class="flex flex-wrap items-center justify-between gap-4 rounded-xl border-2 border-zinc-400/35 bg-zinc-200/80 p-4 sm:p-5 dark:border-zinc-500/45 dark:bg-indigo-800/20">
      <div class="flex items-center gap-4 min-w-0">
        <div class="relative shrink-0">
          @if (u.photoURL) {
          <img [src]="imageService.getImageSource(u.photoURL, 'gallery')"
            alt="Profile picture for {{ u.firstName }} {{ u.lastName }}"
            class="size-24 rounded-full object-cover border border-border/60" />
          } @else {
          <div
            class="size-24 rounded-full border border-border/60 bg-muted/50 flex items-center justify-center text-secondary"
            aria-hidden="true">
            <svg class="size-8" viewBox="0 0 24 24" fill="currentColor">
              <path fill-rule="evenodd"
                d="M18.685 19.097A9.723 9.723 0 0 0 21.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 0 0 3.065 7.097A9.716 9.716 0 0 0 12 21.75a9.716 9.716 0 0 0 6.685-2.653Zm-12.54-1.285A7.486 7.486 0 0 1 12 15a7.486 7.486 0 0 1 5.855 2.812A8.224 8.224 0 0 1 12 20.25a8.224 8.224 0 0 1-5.855-2.438ZM15.75 9a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"
                clip-rule="evenodd" />
            </svg>
          </div>
          }
        </div>

        <button type="button" (click)="toggleEditMode()"
          class="rounded-full p-2 border border-border/60 bg-card/50 hover:opacity-80 transition-opacity cursor-pointer shrink-0"
          [attr.aria-label]="editMode() ? 'Lock profile (view only)' : 'Unlock profile (edit)'"
          [attr.aria-pressed]="editMode()">
          @if (editMode()) {
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-red-500"
            aria-hidden="true">
            <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 9.9-1" />
          </svg>
          } @else {
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-green-500"
            aria-hidden="true">
            <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
          }
        </button>
      </div>

      <div class="flex flex-col items-end gap-1 min-w-0 ml-auto">
        <h1 class="text-lg font-semibold text-primary m-0 text-right">{{ u.firstName }} {{ u.lastName }}</h1>
        @if (u.firebaseUid) {
        <atom-copy-id [value]="u.firebaseUid" label="firebaseUid" align="end" />
        }
      </div>
    </section>

    @if (!editMode()) {
    <section
      class="rounded-xl border-2 border-zinc-400/35 bg-zinc-200/80 p-4 sm:p-5 dark:border-zinc-500/45 dark:bg-indigo-800/20">
      <h2 class="m-0 mb-3 text-base font-semibold tracking-wide text-primary">Email</h2>
      <p class="m-0 mt-1 text-base text-primary">{{ displayValue(u.email) }}</p>
    </section>
    } @else {
    <section
      class="rounded-xl border-2 border-rose-400/35 bg-rose-200/80 p-4 sm:p-5 dark:border-rose-500/45 dark:bg-rose-800/20">
      <h2 class="m-0 mb-3 text-base font-semibold tracking-wide text-primary">Email</h2>
      <p class="m-0 mb-3 text-sm text-accent">Important! Use with caution!</p>
      <p class="m-0 mb-3 text-sm text-secondary">
        Updates Firebase Auth and the user record separately from other profile fields.
      </p>
      <div class="flex flex-col gap-3 sm:flex-row sm:items-end">
        <div class="min-w-0 flex-1">
          <label for="brand-user-email" class="block text-sm text-secondary">Email address</label>
          <input id="brand-user-email" type="email" [formField]="creatorProfileForm.email"
            class="mt-1 block w-full input-primary text-primary" autocomplete="off" />
        </div>
        <button type="button" class="btn-basic btn-primary shrink-0 min-w-36" (click)="saveEmail()"
          [disabled]="!canSaveEmail()">
          {{ emailSavingState() ? 'Updating…' : 'Update email' }}
        </button>
      </div>
      @if (emailJustUpdated()) {
      <div
        class="mt-4 flex flex-col gap-2 rounded-lg border border-zinc-400/30 bg-zinc-100/60 p-3 dark:border-zinc-500/35 dark:bg-zinc-900/40 sm:flex-row sm:items-center sm:justify-between">
        <p class="m-0 text-sm text-secondary">
          Email saved. Optionally send a password reset to the new address.
        </p>
        <button type="button" class="btn-basic btn-secondary-outline shrink-0" (click)="sendPasswordReset()"
          [disabled]="!canSendPasswordReset()">
          {{ passwordResetSendingState() ? 'Sending…' : 'Send password reset email' }}
        </button>
      </div>
      }
    </section>
    }
  </div>
  }
  }
  }

  @if (loadingState() === 'loaded' && creator() && editMode()) {
  <div class="flex flex-row gap-5 items-center justify-center mt-5">
    <button type="button"
      class="profile-corner-action profile-corner-action--reset btn-basic btn-secondary-outline min-w-32"
      (click)="resetProfileEdits()" [disabled]="!canResetProfile()">
      Reset
    </button>
    <button type="button" class="profile-corner-action profile-corner-action--save btn-basic btn-primary min-w-40"
      (click)="saveProfile()" [disabled]="!canSaveProfile()">
      {{ savingState() ? 'Saving…' : 'Save changes' }}
    </button>
  </div>
  }


</div>